<div class="timeline__entry_content">
  <ng-content></ng-content>
</div>



